import angular from 'angular';
import Logger from '../../../shared/logger';

export const CompanyService = (Restangular) => {

    const getCompanySearch = function (data) {
        return Restangular.all('company')
            .all('search')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const searchCompanyByNames = function (names) {
        if (Array.isArray(names)) {
            return Restangular.all('company')
                .all('searchByNames')
                .post({names})
                .catch(error => Logger.error(error));
        }
        return [];
    };

    return {
        getCompanySearch,
        searchCompanyByNames,
    };
};

angular
    .module('TALENYA-FE')
    .factory('CompanyService', CompanyService);
